import { getAssetManagers } from 'bff/hooks/reporting/AssetManagersApi';
import { AssetManagerCard } from './assetManagersCard/AssetManagerCard';
import styles from './top-asset-managers.module.scss';
import { useQuery } from '@tanstack/react-query';
import { Suspense, useContext, useEffect } from 'react';
import WidgetLoader from '../../../../atoms/widget-loader/WidgetLoader';
import WidgetError from '../../../../atoms/widget-error/WidgetError';
import { WidgetContext } from 'modules/dashboard/components/organisms/widget/Widget';
import { useSetWidgetQueryStatus } from 'modules/dashboard/types/widgets/widget.hooks';

export interface AssetManager {
  name: string;
  initials: string;
  someRandValue: number;
  percentageOfBook: number;
  url: string;
}

export const TopAssetManagersWidget = () => {
  const context = useContext(WidgetContext);

  const {
    isError,
    data: assetManagers,
    refetch,
    isFetching,
    isSuccess
  } = useQuery(getAssetManagers());

  useEffect(() => {
    if (!context) return;
    context.setReloadHandler(() => () => {
      refetch();
    });
  }, []);

  useSetWidgetQueryStatus({ isFetching, isError, isSuccess, context });

  if (isFetching) return <WidgetLoader />;
  if (isError) return <WidgetError onRefresh={refetch} isRefreshing={isFetching} />;

  return (
    <Suspense fallback={<WidgetLoader />}>
      {assetManagers ? (
        <div className={styles.topAssetManagersList} data-testid={'topAssetManagersList'}>
          {assetManagers.map((assetManager, index) => (
            <AssetManagerCard
              assetManager={assetManager}
              index={index}
              key={assetManager.assetManagerName + assetManager.companyURL}
            />
          ))}
        </div>
      ) : (
        <WidgetError onRefresh={refetch} isRefreshing={isFetching} />
      )}
    </Suspense>
  );
};
